import { createSlice } from '@reduxjs/toolkit';
import { createSelectOptions } from '../../../../utils';

function sortAndFilterOptionValues(values) {
	return values.sort().filter((value) => value !== '');
}

const initialState = {
	vehicleTree: {},
	year: {
		selected: null,
		options: [],
	},
	make: {
		selected: null,
		options: [],
	},
	model: {
		selected: null,
		options: [],
	},
	subModel: {
		selected: null,
		options: [],
	},
};

const vehicleFiltersSlice = createSlice({
	name: 'newOrder/productsSearch/vehicleFilters',
	initialState,
	reducers: {
		loadVehicleTree(state, { payload: vehicleTree }) {
			const yearOptions = createSelectOptions(
				sortAndFilterOptionValues(Object.keys(vehicleTree)).reverse(),
				false,
			);

			return {
				...initialState,
				vehicleTree,
				year: {
					selected: null,
					options: yearOptions,
				},
			};
		},
		setSelectedYear(state, { payload: selectedYear }) {
			const options = createSelectOptions(
				sortAndFilterOptionValues(
					Object.keys(state.vehicleTree[selectedYear] || {}),
				),
				false,
			);

			return {
				...state,
				year: {
					...state.year,
					selected: selectedYear,
				},
				make: {
					selected: null,
					options,
				},
				model: {
					...initialState.model,
				},
				subModel: {
					...initialState.subModel,
				},
			};
		},
		setSelectedMake(state, { payload: selectedMake }) {
			const options = createSelectOptions(
				sortAndFilterOptionValues(
					Object.keys(
						state.vehicleTree[state.year.selected]?.[
							selectedMake
						] || {},
					),
				),
				false,
			);

			return {
				...state,
				make: {
					...state.make,
					selected: selectedMake,
				},
				model: {
					selected: null,
					options,
				},
				subModel: {
					...initialState.subModel,
				},
			};
		},
		setSelectedModel(state, { payload: selectedModel }) {
			const options = createSelectOptions(
				sortAndFilterOptionValues(
					state.vehicleTree[state.year.selected]?.[
						state.make.selected
					]?.[selectedModel] || [],
				),
				false,
			);

			return {
				...state,
				model: {
					...state.model,
					selected: selectedModel,
				},
				subModel: {
					selected: null,
					options,
				},
			};
		},
		setSelectedSubModel(state, { payload: selectedSubModel }) {
			return {
				...state,
				subModel: {
					...state.subModel,
					selected: selectedSubModel,
				},
			};
		},
	},
});

export { initialState };
export const {
	loadVehicleTree,
	setSelectedYear,
	setSelectedMake,
	setSelectedModel,
	setSelectedSubModel,
} = vehicleFiltersSlice.actions;

export default vehicleFiltersSlice.reducer;
